// 当前地址
export const CURRENT_ADDRESS = 'CURRENT_ADDRESS'
// 购物车数量
export const SHOPCART_NUM = 'SHOPCART_NUM'
// 修改地址
export const EDIT_ADDRESS = 'EDIT_ADDRESS'
// 分类列表
export const CATEGORY_LIST = 'CATEGORY_LIST'
// 是否展示侧边栏
export const SLIDE_BAR_SHOW_FLAG = 'SLIDE_BAR_SHOW_FLAG'
// loading
export const FETCH_LOADING = 'FETCH_LOADING'
// 首页轮播
export const SWIPER_INDEX = 'SWIPER_INDEX'
// 商品详情
export const GOODS_DETAIL = 'GOODS_DETAIL'
// 商品评价
export const GOODS_COMMENT = 'GOODS_COMMENT'
// 分类id
export const TYPE_ID = 'TYPE_ID'
// 是否是iphoneX
export const IS_IPX = 'IS_IPX'
export const HOTEL_CODE = 'HOTEL_CODE'
export const IS_OPENSHARE = 'IS_OPENSHARE';
export const KEEP_ALIVE = 'KEEP_ALIVE';





// WEBPACK FOOTER //
// ./src/store/types.js